module.exports = __webpack_public_path__ + "media/Land of arrogance.c973b0dd.mp3";